<template>
  <div id="track" class="container">
    <div v-visibility-change="visibilityChange">
      <NavBar class="t-navbar" :is-map="flags.isTracker" :is-cash="isCash" />
      <div>
        <transition name="fade" mode="out-in">
          <div v-if="!flags.isTracker" id="main-statu-layer">
            <!-- Lottie animation -->
            <div ref="lavContainer" :style="animationStyle" />
            <!-- Status text -->
            <div>
              <h5 class="message-body">
                {{ order.customIndicators.statusMessageBody }}
              </h5>
            </div>
          </div>
        </transition>
        <el-row type="flex" justify="center">
          <transition name="fade" mode="out-in">
            <Map
              v-if="flags.isTracker"
              :key="map.componentKey"
              :driver="driver.coords"
              :branch="branch.coords"
              :delivery="delivery.coords"
              :disconnected-route-coordinates="disconnectedRouteCoordinates"
              :animation-disconnected="animationDisconnected" />
          </transition>
        </el-row>
        <div class="delivery-man-track">
          <transition name="fade" mode="out-in">
            <delivery-man-detail
              v-if="!flags.loading"
              :address="getOrderAddreess(order)"
              :total="order.totalAmount"
              :currency="order.currencyType"
              :folio="order.folio"
              :order="order"
              :estimated-time="estimatedTime"
              :wa-phone="order.whatsapp"
              class="dm-s"
              @on-view-folio-status="onViewFolioStatus" />
          </transition>
        </div>
        <el-dialog
          id="status-dialog"
          :visible.sync="flags.isStatusDialog"
          close-on-press-escape
          :title="$t('general.folioStatus')"
          width="90%"
          center>
          <task-card-steps
            v-model="order"
            @close="onClose" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import TemplateMethods from '@/utils/mixins/templateMethods'
import DeliveryManDetail from '@/components/DeliveryManDetail'

export default {
  name: 'TaskTrack',
  components: {
    DeliveryManDetail
  },
  mixins: [TemplateMethods]
}
</script>
<style>
.t-navbar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 3;
}
.t-address-bar {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
  position: absolute;
  top: 20px;
  left: 20px;
  width: calc(100% - 40px);
  z-index: 3;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  border-radius: 8px;
  background-color: white;
  -webkit-box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  -moz-box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  -ms-box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  -o-box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  box-shadow: 4px 4px 10px rgba(162, 162, 165, 0.7);
  padding: 16px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-justify-content: flex-start;
  -moz-justify-content: flex-start;
  -ms-justify-content: flex-start;
  -o-justify-content: flex-start;
  justify-content: flex-start;
}

.t-address-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -o-align-items: center;
  align-items: center;
  margin-right: 8px;
  -webkit-align-self: flex-start;
  -moz-align-self: flex-start;
  -ms-align-self: flex-start;
  -o-align-self: flex-start;
  align-self: flex-start;
}

.t-address-container .el-icon-arrow-left {
  cursor: pointer;
  margin-right: 6px;
  margin-top: 2px;
}

.t-address-delivery {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1875px;
  color: #170B56;
}

span.t-address-value {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1875px;
  color: #170B56;
  opacity: 0.2;
  -webkit-text-transform: capitalize;
  -moz-text-transform: capitalize;
  -ms-text-transform: capitalize;
  -o-text-transform: capitalize;
  text-transform: capitalize;
}

.btn-center-path svg {
  width: 20px;
  height: 20px;
  color: white;
}

.delivery-man-track {
  position: fixed;
  bottom: 0;
  max-width: 500px;
  width: 100%;
  overflow: hidden;
  background: #FFFFFF;
  min-height: 32vh;
  -webkit-box-shadow: 1px -4px 10px rgba(162, 162, 165, 0.7);
  -moz-box-shadow: 1px -4px 10px rgba(162, 162, 165, 0.7);
  -ms-box-shadow: 1px -4px 10px rgba(162, 162, 165, 0.7);
  -o-box-shadow: 1px -4px 10px rgba(162, 162, 165, 0.7);
  box-shadow: 1px -6px 10px rgba(162,162,165,0.3);
  z-index: 3;
}

.marker-driver-x {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid white;
  box-shadow: 0px 3px 30px #CAD1D8;
  background: #efefef;
}

.btn-track {
  position: absolute !important;
  bottom: 46vh !important;
  right: 16px !important;
  height: 40px !important;
  width: 40px !important;
}

</style>
